import { routes } from '../../lib/routes';
import { DevicesTestingStatusMeta, SerializedDevicesTestingRecord } from '../../model/devicesTestingForm';
import { Channel } from '../../model/skill';
import { callApi } from '../utils';

export const getDevicesTestingRecordStatus = (skillId: string, channel: Channel) => {
    return callApi<DevicesTestingStatusMeta>({
        method: 'GET',
        url: routes.app.appStoreApi(`/apps/${skillId}/testing-date/status`),
        queryParams: { channel },
    });
};

export const saveDevicesTestingOptions = (skillId: string, channel: Channel, body: SerializedDevicesTestingRecord) => {
    return callApi<SerializedDevicesTestingRecord>({
        method: 'POST',
        url: routes.app.appStoreApi(`/apps/${skillId}/testing-date`),
        queryParams: { channel },
        data: body,
    });
};
